import config from 'config.json';

export const API_BASE_URL = config.serverURL;
export const API_REQUEST = Symbol('API_REQUEST');



// WEBPACK FOOTER //
// ./src/core/api/constants.js